import { OnboardingType } from 'models/lead.model'
import type { TPlansDecorations } from 'models/plan-decoration.model'

export const PLANS_DECORATIONS_INTL_D60: TPlansDecorations = {
  USD: {
    [OnboardingType.PURCHASE]: [
      {
        name: 'plan1',
        decoratedPrice: '$5.59',
        decoratedStrikethroughPrice: '$13.99',
        decoratedPricePerDay: '$0.80',
        title: '1-week trial',
        totalPriceText: '$5.59',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        introPeriodDays: 7,
        discountBadgeText: '60%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 5.59,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_7_days_5.59',
        productPrice: '5.59+39.99',
      },
      {
        name: 'plan2',
        isDefault: true,
        decoratedPrice: '$15.99',
        decoratedStrikethroughPrice: '$39.99',
        decoratedPricePerDay: '$0.53',
        title: '4-week plan',
        totalPriceText: '$15.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introPeriodDays: 28,
        discountBadgeText: '60%',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 15.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_1_mo_15.99',
        productPrice: '15.99+39.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '$31.99',
        decoratedStrikethroughPrice: '$79.99',
        decoratedPricePerDay: '$0.36',
        title: '12-week plan',
        totalPriceText: '$31.99',
        trialBadgeText: '',
        subscriptionPriceText: '$79.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        introPeriodDays: 84,
        discountBadgeText: '60%',
        analyticsPrice: 79.99,
        analyticsTrialPrice: 31.99,
        analyticsProductName: 'intellio_USD_3_mo_79.99_intro_3_mo_31.99',
        productPrice: '31.99+79.99',
      },
      // Full-price fallback plans, rendered once the offer countdown expires.
      {
        name: 'plan4',
        decoratedPrice: '$13.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '$1.99',
        title: '1-week trial',
        totalPriceText: '$13.99',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        introPeriodDays: 7,
        discountBadgeText: '',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 13.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99_intro_7_days_13.99',
        productPrice: '13.99+39.99',
      },
      {
        name: 'plan5',
        decoratedPrice: '$39.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '$1.33',
        title: '4-week plan',
        totalPriceText: '$39.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        hasIntroPeriod: false,
        discountBadgeText: '',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 39.99,
        analyticsProductName: 'intellio_USD_1_mo_39.99',
        productPrice: '39.99',
      },
      {
        name: 'plan6',
        decoratedPrice: '$79.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '$0.88',
        title: '12-week plan',
        totalPriceText: '$79.99',
        trialBadgeText: '',
        subscriptionPriceText: '$79.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        hasIntroPeriod: false,
        discountBadgeText: '',
        analyticsPrice: 79.99,
        analyticsTrialPrice: 79.99,
        analyticsProductName: 'intellio_USD_3_mo_79.99',
        productPrice: '79.99',
      },
    ],
    // Intro = ½ full price (50% off).
    [OnboardingType.PDF_UPSELL]: [
      {
        name: 'plan1',
        decoratedPrice: '$6.99',
        decoratedStrikethroughPrice: '$13.99',
        title: 'Double weekly content',
        totalPriceText: '$6.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '7d',
        introPeriodDays: 7,
        discountBadgeText: '50% off',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 6.99,
        analyticsProductName: 'intellio_doublepdf_1_mo_39.99_intro_7_days_6.99',
        productPrice: '6.99+39.99',
      },
      {
        name: 'plan2',
        decoratedPrice: '$19.99',
        decoratedStrikethroughPrice: '$39.99',
        title: 'Double weekly content',
        totalPriceText: '$19.99',
        trialBadgeText: '',
        subscriptionPriceText: '$39.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '4week',
        introPeriodDays: 28,
        discountBadgeText: '50% off',
        analyticsPrice: 39.99,
        analyticsTrialPrice: 19.99,
        analyticsProductName: 'intellio_doublepdf_1_mo_39.99_intro_1_mo_19.99',
        productPrice: '19.99+39.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '$29.99',
        decoratedStrikethroughPrice: '$59.99',
        title: 'Double weekly content',
        totalPriceText: '$29.99',
        trialBadgeText: '',
        subscriptionPriceText: '$59.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        introBillingPeriod: '12week',
        introPeriodDays: 84,
        discountBadgeText: '50% off',
        analyticsPrice: 59.99,
        analyticsTrialPrice: 29.99,
        analyticsProductName: 'intellio_doublepdf_3_mo_59.99_intro_3_mo_29.99',
        productPrice: '29.99+59.99',
      },
    ],
  },
  GBP: {
    [OnboardingType.PURCHASE]: [
      {
        name: 'plan1',
        decoratedPrice: '£5.99',
        decoratedStrikethroughPrice: '£11.99',
        decoratedPricePerDay: '£0.86',
        title: '1-week trial',
        totalPriceText: '£5.99',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        introPeriodDays: 7,
        discountBadgeText: '50%',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 5.99,
        analyticsProductName: 'intellio_GBP_1_mo_29.99_intro_7_days_5.99',
        productPrice: '5.99+29.99',
      },
      {
        name: 'plan2',
        isDefault: true,
        decoratedPrice: '£14.99',
        decoratedStrikethroughPrice: '£29.99',
        decoratedPricePerDay: '£0.54',
        title: '4-week plan',
        totalPriceText: '£14.99',
        trialBadgeText: '',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introPeriodDays: 28,
        discountBadgeText: '50%',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 14.99,
        analyticsProductName: 'intellio_GBP_1_mo_29.99_intro_1_mo_14.99',
        productPrice: '14.99+29.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '£29.99',
        decoratedStrikethroughPrice: '£59.99',
        decoratedPricePerDay: '£0.36',
        title: '12-week plan',
        totalPriceText: '£29.99',
        trialBadgeText: '',
        subscriptionPriceText: '£59.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        introPeriodDays: 84,
        discountBadgeText: '50%',
        analyticsPrice: 59.99,
        analyticsTrialPrice: 29.99,
        analyticsProductName: 'intellio_GBP_3_mo_59.99_intro_3_mo_29.99',
        productPrice: '29.99+59.99',
      },
      // Full-price fallback plans, rendered once the offer countdown expires.
      {
        name: 'plan4',
        decoratedPrice: '£11.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '£1.71',
        title: '1-week trial',
        totalPriceText: '£11.99',
        trialBadgeText: '4-week plan',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '1-week',
        introPeriodDays: 7,
        discountBadgeText: '',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 11.99,
        analyticsProductName: 'intellio_GBP_1_mo_29.99_intro_7_days_11.99',
        productPrice: '11.99+29.99',
      },
      {
        name: 'plan5',
        decoratedPrice: '£29.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '£1.07',
        title: '4-week plan',
        totalPriceText: '£29.99',
        trialBadgeText: '',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        hasIntroPeriod: false,
        discountBadgeText: '',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 29.99,
        analyticsProductName: 'intellio_GBP_1_mo_29.99',
        productPrice: '29.99',
      },
      {
        name: 'plan6',
        decoratedPrice: '£59.99',
        decoratedStrikethroughPrice: '',
        decoratedPricePerDay: '£0.71',
        title: '12-week plan',
        totalPriceText: '£59.99',
        trialBadgeText: '',
        subscriptionPriceText: '£59.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        hasIntroPeriod: false,
        discountBadgeText: '',
        analyticsPrice: 59.99,
        analyticsTrialPrice: 59.99,
        analyticsProductName: 'intellio_GBP_3_mo_59.99',
        productPrice: '59.99',
      },
    ],
    [OnboardingType.PDF_UPSELL]: [
      {
        name: 'plan1',
        decoratedPrice: '£5.99',
        decoratedStrikethroughPrice: '£11.99',
        title: 'Double weekly content',
        totalPriceText: '£5.99',
        trialBadgeText: '',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '7d',
        introPeriodDays: 7,
        discountBadgeText: '50% off',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 5.99,
        analyticsProductName:
          'intellio_doublepdf_GBP_1_mo_29.99_intro_7_days_5.99',
        productPrice: '5.99+29.99',
      },
      {
        name: 'plan2',
        decoratedPrice: '£14.99',
        decoratedStrikethroughPrice: '£29.99',
        title: 'Double weekly content',
        totalPriceText: '£14.99',
        trialBadgeText: '',
        subscriptionPriceText: '£29.99 every 4 weeks',
        periodIntervalForSubscriptionDescription: '4 weeks',
        introBillingPeriod: '4week',
        introPeriodDays: 28,
        discountBadgeText: '50% off',
        analyticsPrice: 29.99,
        analyticsTrialPrice: 14.99,
        analyticsProductName:
          'intellio_doublepdf_GBP_1_mo_29.99_intro_1_mo_14.99',
        productPrice: '14.99+29.99',
      },
      {
        name: 'plan3',
        decoratedPrice: '£22.99',
        decoratedStrikethroughPrice: '£44.99',
        title: 'Double weekly content',
        totalPriceText: '£22.99',
        trialBadgeText: '',
        subscriptionPriceText: '£44.99 every 12 weeks',
        periodIntervalForSubscriptionDescription: '12 weeks',
        introBillingPeriod: '12week',
        introPeriodDays: 84,
        discountBadgeText: '50% off',
        analyticsPrice: 44.99,
        analyticsTrialPrice: 22.99,
        analyticsProductName:
          'intellio_doublepdf_GBP_3_mo_44.99_intro_3_mo_22.99',
        productPrice: '22.99+44.99',
      },
    ],
  },
}
